/**
 * One width ladder for every product photo in the app.
 *
 * Surfaces take a contiguous slice of this list rather than defining their own
 * rungs. Cloudflare bills image resizing per unique (image, options) pair per
 * month, so two rungs a few percent apart — 336 and 384, or 1200 and 1280 —
 * are charged twice for one visible result. Sharing the values means a width
 * requested by the cart is the same transformation the PLP already paid for.
 *
 * The rungs were measured against the rendered slots at 1x/2x/3x; the ceiling
 * is 1440 because that is the master width and Cloudflare never upscales.
 * See docs/tech/responsive-images.md.
 */
export const PRODUCT_IMAGE_WIDTHS = [
  112, 224, 384, 512, 640, 828, 1080, 1200, 1290, 1440,
];

function between(min: number, max: number): number[] {
  return PRODUCT_IMAGE_WIDTHS.filter((width) => width >= min && width <= max);
}

/** Cart line item — a fixed 100–112px slot. */
export const CART_IMAGE_WIDTHS = between(112, 384);

/**
 * PLP tiles and carousel slides. Tiles run 140–290px; a mobile carousel slide
 * is a full viewport width, which is what the top of the range covers — 1290
 * is 430x3, the widest current phone at native density. The rung is shared
 * with the PDP carousel, so reaching it costs no extra transformation.
 */
export const PRODUCT_CARD_WIDTHS = between(224, 1290);

/** PDP desktop grid — half- and full-width slots, hidden below `md`. */
export const PDP_GRID_IMAGE_WIDTHS = between(512, 1440);

/** PDP mobile carousel — one slide per viewport width. */
export const PDP_CAROUSEL_IMAGE_WIDTHS = between(640, 1290);

/** PDP lightbox — always the full master, never viewport-dependent. */
export const PDP_ZOOM_IMAGE_WIDTHS = [1440];

export const GATED_PRODUCT_CARD_WIDTHS = [224];
